import { Injectable } from '@angular/core';

import { GraphQLService, DataService } from '@app/services';
import { queryWidget } from '@app/graphql-queries';
import { Widget } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {
    
    constructor(
        private graphQLService: GraphQLService,
        private dataService: DataService
    ) { }
    
    async fetchWidget(widgetID: string) : Promise<any|null> {
        let widget: any|null = null;
        let response = await this.graphQLService.query({            
            query: queryWidget,
            variables: {
                ID: widgetID
            }
        }, 'public');              
        if(response?.data?.Widget){
            widget = response.data.Widget;
        }
        return widget;
    }
    
    async refreshWidget(){
        let widget = await this.fetchWidget(this.dataService.operation.value.widgetID);
        if(widget){
            this.dataService.widget = new Widget(widget);
        }
    }
}
